import EventItem from './event-item';

export default EventItem;
